<template>
  <v-app :dark="theme.isDark">
    <div class="app-layout">
      <router-view />
    </div>

    <info-modal />
  </v-app>
</template>

<script>
import theme from '@/factories/theme';
import intercom from '@/lib/intercom';
import InfoModal from '@/components/basic/info-modal/InfoModal';

export default {
  name: 'AuthLayout',
  components: {
    InfoModal,
  },
  data() {
    return {
      theme,
    };
  },
  mounted() {
    intercom.init({ hide_default_launcher: false });
  },
};
</script>
